import { formatDateTimeReadable, Kyc } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { StandardActionDialog } from '../../../../../../../../shared/components/StandardActionDialog/StandardActionDialog';
import { SelectMenuWithIcon } from '../../../../../../../../shared/components/SuperSearchBar/components/SearchBarControls/components/SelectMenuWithIcon';
import { Text } from '../../../../../../../../shared/components/Text';
import { KycForm } from './components/KycForm';

interface KycDataDialogProps {
  opened: boolean;
  setOpened: (boolean) => void;
  kyc: Kyc[];
  setActionDialogParams: (any) => void;
}

export const KycDataDialog = ({ opened, setOpened, setActionDialogParams, kyc }: KycDataDialogProps) => {
  const [selectedKyc, setSelectedKyc] = useState(0);

  return (
    <StandardActionDialog
      titleTextElement={<Text tId={'KYC_DATA'} />}
      opened={opened}
      setOpened={setOpened}
      setActionDialogParams={setActionDialogParams}
      altCancelButtonTextId={'CLOSE'}
    >
      <>
        <SelectMenuWithIcon
          optionsArray={kyc.map((kyc, i) => ({
            display: formatDateTimeReadable(kyc.createdAt),
            onClick: () => setSelectedKyc(i),
            currentSelection: selectedKyc === i,
          }))}
          titleTextId={'SELECT_KYC'}
          iconName={'badge'}
        />
        <KycForm kyc={kyc[selectedKyc]} />
      </>
    </StandardActionDialog>
  );
};
